import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SuccessMessage } from '@eggplant/pattern-library'
import { useKeycloak } from '@eggplant/context'
import type { SmtpSettings } from '@eggplant/types'

interface Props {
  onError: () => void
  onSuccess: (response: SmtpSettings) => void
  params: SmtpSettings
}

const SaveSmtpRequest = ({
  onError,
  onSuccess,
  params
}: Props) => {
  const { keycloak: keycloakInstance } = useKeycloak()

  const url = `${keycloakInstance.authServerUrl}realms/${keycloakInstance.realm}/dai/v1/smtp`

  return (
    <AuthenticatedDataRequest
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    >{
        () => (
          <SuccessMessage>
            SMTP settings saved successfully.
          </SuccessMessage>
        )
      }
    </AuthenticatedDataRequest>
  )
}

export default SaveSmtpRequest
